import React from 'react';
import WorkRegisterDashboard from './WorkRegisterDashboard';

const WorkRegisterList = () => <WorkRegisterDashboard mode="personal" />;

export default WorkRegisterList;
